import { __rest } from "tslib";
import { getAdjustedDirection, getElementTransformedPosition, } from '../../../../utils/animationsUtils';
import { deg2rad } from '@wix/wow-utils';
const name = 'TurnIn';
const properties = { schema: {} };
const paramsMap = {
    'top-left': { idx: 0, x: '0%', y: '0%', angle: -50 },
    'top-right': { idx: 1, x: '100%', y: '0%', angle: 50 },
    'bottom-right': { idx: 2, x: '100%', y: '100%', angle: 50 },
    'bottom-left': { idx: 3, x: '0%', y: '100%', angle: -50 },
};
const easingMap = {
    soft: { easing: 'cubicInOut' },
    medium: { easing: 'quintInOut' },
    hard: { easing: 'backOut' },
};
function animate(kit, elements, duration, delay, _a = {}) {
    var { direction = 'top-left', // fix here
    easing = 'backOut', power } = _a, params = __rest(_a, ["direction", "easing", "power"]);
    const sequence = kit.sequence(params);
    const ease = typeof power !== 'undefined' ? easingMap[power].easing : easing;
    sequence.add(kit.animate('BaseFade', elements, duration * 0.6, delay, {
        from: { opacity: 0 },
        to: { opacity: 1 },
        ease: 'sineIn',
    }));
    elements.forEach((element) => {
        const elementAngleInDeg = Number(kit.engine.getProperty(element, '--comp-rotate-z') || 0);
        const adjDirection = getAdjustedDirection(paramsMap, direction, elementAngleInDeg);
        const origin = paramsMap[adjDirection];
        const angle = paramsMap[direction].angle;
        const { x, y } = getElementTransformedPosition(origin, kit.engine.getBoundingRect(element), deg2rad(elementAngleInDeg));
        sequence
            .add(kit.engine.set(element, {
            x,
            y,
            transformOrigin: `${origin.x} ${origin.y}`,
        }), 0)
            .add(kit.animate('BaseRotate', element, duration, delay, {
            from: { rotation: `+=${angle}` },
            ease,
        }), 0);
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=turnIn.js.map